import type { AccordionContentPassThroughOptions } from "primevue/accordioncontent";

export const accordioncontent: AccordionContentPassThroughOptions = {
  root: "pl-9"
};
